import { render, staticRenderFns } from "./My-Plan.vue?vue&type=template&id=7062ac77&scoped=true&"
import script from "./My-Plan.vue?vue&type=script&lang=js&"
export * from "./My-Plan.vue?vue&type=script&lang=js&"
import style0 from "./My-Plan.vue?vue&type=style&index=0&id=7062ac77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7062ac77",
  null
  
)

export default component.exports